<a
  *ngIf="product"
  class="product-link"
  [routerLink]="['/product', product.id, title]"
  [state]="{ hasNavigated: true, homeIndexData }"
  (click)="onProduct()"
>
  <div class="item-container">
    <div class="item-image-co">
      <img
        class="item-image"
        defaultImage="assets/images/cards/ic_placeholder.png"
        [lazyLoad]="
          product.store_product_logo ? product.store_product_logo : product.logo
        "
        [alt]="
          product.store_product_name ? product.store_product_name : product.name
        "
      />
    </div>

    <div class="item-context">
      <p class="product-name">
        {{
          product?.store_product_name
            ? product?.store_product_name
            : product?.name
        }}
      </p>
      <div class="product-price-discount">
        <p class="product-price">
          <span class="prefix-text">Price:</span>
          <span class="price-text">
            {{ priceLabel }}
          </span>
        </p>
        <div class="discount-badge-container" *ngIf="product.discount > 0">
          <div class="badge-symbol">
            <div class="symbol-line"></div>
            <div class="symbol-circle"></div>
          </div>
          <div class="badge-primary">
            {{ product.discount | convertPrice
            }}<span class="badge-primary-icon">%</span>
          </div>
          <div class="badge-secondary">
            <span class="badge-context">Discount</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</a>
